@let user = user$ | async;
<div class="user-info-wrapper">
  @if (isLoading) {
    <div class="user-name-wrapper">
      <ngx-skeleton-loader
        count="1"
        appearance="circle"
        [theme]="{ width: '40px', height: '40px' }"></ngx-skeleton-loader>
      <div class="displayname-wrapper">
        <ngx-skeleton-loader count="1" [theme]="{ width: '120px', height: '20px' }"></ngx-skeleton-loader>
        <ngx-skeleton-loader count="1" [theme]="{ width: '180px', height: '24px' }"></ngx-skeleton-loader>
      </div>
    </div>
    <div class="user-status">
      <ngx-skeleton-loader count="1" [theme]="{ width: '80px', height: '20px' }"></ngx-skeleton-loader>
    </div>
  } @else {
    <div class="user-name-wrapper">
      <mat-icon class="user-avatar" svgIcon="default-user-icon"></mat-icon>
      <div class="displayname-wrapper">
        <div style="display: flex">
          <div class="displayname">
            <span [attr.data-testid]="testIds.userDisplayname">{{ user?.displayname }}</span>
            @if (!editDisplaynameOpen && !user?.deactivated) {
              <mat-icon
                tabindex="0"
                [attr.data-testid]="testIds.editDisplaynameBtn"
                (click)="openDisplaynameEdit()"
                (keydown.enter)="openDisplaynameEdit()"
                class="edit-icon"
                svgIcon="edit">
              </mat-icon>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="user-status">
      <div class="status-container">
        @if (user?.deactivated) {
          <span class="status-item status-deleted"></span>
        } @else {
          <span class="status-item status-active"></span>
        }
        <p [attr.data-testid]="testIds.userStatus">{{ user?.deactivated ? 'Gelöscht' : 'Aktiv' }}</p>
      </div>
    </div>
  }
</div>

@if (editDisplaynameOpen) {
  <mat-label class="chat-label">Anzeigename</mat-label>
  <div class="user-displayname-change">
    <mat-form-field appearance="outline" class="form-field">
      <input
        matInput
        [attr.data-testid]="testIds.editDisplaynameInput"
        placeholder="Neuer Anzeigename"
        [(ngModel)]="newDisplayName" />
    </mat-form-field>
    <div class="displayname-change-actions">
      <button
        [attr.data-testid]="testIds.cancelEditDisplaynameBtn"
        (click)="cancelDisplaynameEdit()"
        matTooltip="Abbrechen"
        class="inline-cancel">
        <mat-icon svgIcon="xmark" />
      </button>
      <button
        [attr.data-testid]="testIds.submitEditDisplaynameBtn"
        (keydown)="$event.stopPropagation()"
        [disabled]="!newDisplayName"
        class="inline-accept"
        matTooltip="Anzeigenamen ändern"
        (click)="changeDisplayname()">
        <mat-icon svgIcon="check" />
      </button>
    </div>
  </div>
}
<button
  class="icon-btn"
  [attr.data-testid]="testIds.userDeleteBtn"
  (click)="deleteUser()"
  [disabled]="user?.deactivated">
  <mat-icon svgIcon="user-minus"></mat-icon>
  Nutzer löschen
</button>
<hr />
